import { Subscription } from 'rxjs';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DataPrintService, PrintInterface, PrintModeEnum } from '@sparte/ui';
import { ElectronStockService } from '../../services/electron-stock.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'sparte-print-page',
  templateUrl: './print-page.component.html',
  styleUrls: ['./print-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintPageComponent implements OnInit, OnDestroy {
  public printOrder: PrintInterface;
  private readonly defaultPrintOrder: PrintInterface = {
    mode: PrintModeEnum.EntityLabel,
    barcodeData: null
  }
  private printSub: Subscription;

  constructor(
    private dataPrintService: DataPrintService,
    private electronStockService: ElectronStockService,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef
  ) {
    this.printOrder = this.defaultPrintOrder;
  }

  ngOnInit(): void {
    this.printSub = this.dataPrintService.printEvent.subscribe(printOrder => {
      this.printOrder = printOrder;
      this.cdRef.detectChanges();
      if (this.electronStockService.isInElectron && this.printOrder.mode === PrintModeEnum.ShipmentSlip) {
        this.electronStockService.eventSubscribeOnce('print', ({ eventType, message, filePath, error }) => {
          console.log(eventType, filePath);
          switch (eventType) {
            case 'success':
              this.toastr.success(`PDF saved at ${filePath}`, message);
              break;
            case 'error':
              this.toastr.error(error, 'Print failed');
              break;
            case 'cancelled':
              break;
          }
          this.printOrder = this.defaultPrintOrder;
          this.cdRef.detectChanges();
        });
        this.electronStockService.sendMessage('print', `BL_${printOrder.shipmentData.entityBarcode}`);
      }
      else {
        window.print();
        this.printOrder = this.defaultPrintOrder;
        this.cdRef.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this.printSub?.unsubscribe();
  }
}
